export default __webpack_public_path__ + "static/media/naidi-2-4.e1c42803.svg";